import { all, fork, call, put, takeEvery, CallEffect, PutEffect } from "redux-saga/effects";
import { onCreateNewLetterSuccess } from "../actions";
import { ActionTypes } from "../../constants/ActionTypes";
import { ShowError } from "../../helper/Alert";
import FaraGostarDynamicHttp from "../../api/FaraGostarDynamicHttp";
import { AxiosResponse } from "axios";

// newLetter
const createLetter = async (letterTemplateId: string) => {
    let http = await FaraGostarDynamicHttp();
    return await http.post(`Letter/CreateLetter`, {
        letterTemplateId: letterTemplateId
    });
}

function* createLetterRequest(action: any): Generator<CallEffect<AxiosResponse<any>> | PutEffect<{ type: ActionTypes; payload: any; }>, void, AxiosResponse<any>> {
    try {
        const letterCode = yield call(createLetter, action.payload);
        yield put(onCreateNewLetterSuccess(letterCode));
    } catch (error) {
        return ShowError("", error);
    }
}

export function* createNewLetter() {
    yield takeEvery(ActionTypes.CREATE_LETTER, createLetterRequest);
}

export default function* rootSaga() {
    yield all([fork(createNewLetter)]);
}
